import { Comment, Fragment, isVNode, type VNode } from "vue";

export function normalizeVNode(nodes: VNode[] | undefined): VNode[] {
	if (nodes == null || !Array.isArray(nodes)) {
		return [];
	}

	const normalized: VNode[] = [];

	for (const node of nodes) {
		if (!isVNode(node)) {
			continue;
		}

		if (node.type === Comment) {
			continue;
		}

		if (node.type === Fragment) {
			normalized.push(...normalizeVNode(node.children as VNode[]));
		} else {
			normalized.push(node);
		}
	}

	return normalized;
}
